import type { TFunction } from "i18next";

export default function getCategoryNameFromCategoryId(t: TFunction, categoryId: string) {
    return t(`recognitionPrompts.category${categoryId}`);
}